<div class="col-md-12 mb-30 ic-page">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center flex-wrap">
        <h4 class="mb-0">الگوهای کنترل میانی</h4>
      </div>

      <div class="row mt-3">
        <div class="form-group col-md-6">
          <label>جستجو</label>
          <input [(ngModel)]="search" name="Filter_title" type="text" class="form-control"
            placeholder="جستجو بر اساس کد یا عنوان" (keyup.enter)="load()">
        </div>
        <div class="form-group col-md-3">
          <label>وضعیت</label>
          <select class="custom-select" [(ngModel)]="status">
            <option [ngValue]="true">فعال</option>
            <option [ngValue]="false">غیرفعال</option>
            <option [ngValue]="undefined">همه</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-9">
          <button type="button" (click)="load()" class="btn btn-info" style="margin-left:5px"><i
              class="fa fa-search"></i> جستجوی اطلاعات</button>
          <button (click)="add()" type="button" class="btn btn-success" style="margin-left: 5px;"><i
              class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>

          <img *ngIf="loading" src="assets/Loading.gif" style="width:25px" alt="در حال دریافت اطلاعات">
        </div>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color:#489b39;color:white">
            <tr>
              <th>#</th>
              <th>کد کنترل میانی</th>
              <th>عنوان</th>
              <th>نسخه</th>
              <th>تعداد آیتم</th>
              <th>زمان تقریبی</th>
              <th>وضعیت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of items | paginate:{id:'IC_TemplateList_Table',itemsPerPage:50,currentPage:page,totalItems:items.length};let i=index">
              <td>{{(page-1)*50+i+1}}</td>
              <td>{{item.iC_Code}}</td>
              <td>{{item.iC_Title}}</td>
              <td>{{item.version}}</td>
              <td>{{item.itemCount || 0}}</td>
              <td>{{item.time_Estimated || '-'}}<span *ngIf="item.time_Estimated"> دقیقه</span></td>
              <td>
                <p *ngIf="item.status" style="color:#489b39">فعال</p>
                <p *ngIf="!item.status" style="color:crimson">غیر فعال</p>
              </td>
              <td>
                <div class="btn-group" role="group"><button type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">امکانات</button>
                  <div class="dropdown-menu"><a class="dropdown-item" style="cursor:pointer" (click)="edit(item.id)"><i
                        class="fa fa-edit"></i> مشاهده / ویرایش</a><a class="dropdown-item" style="cursor:pointer"
                      (click)="version(item.id)"><i class="fa fa-copy"></i> ایجاد نسخه جدید</a></div>
                </div>
              </td>
            </tr>
            <tr *ngIf="items.length===0">
              <td colspan="8" class="text-center">رکوردی وجود ندارد.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="IC_TemplateList_Table" nextLabel="بعدی" previousLabel="قبلی"
      (pageChange)="page=$event"></pagination-controls>
  </div>
</div>
